<template>

    <graph
        :graph-endpoint="route('api.v1.financial.graph.index')"
    ></graph>

</template>

<script>

    import Graph from "../../components/Business/Graph";

    export default {

        components: {
            Graph,
        },

        metaInfo: {
            title:'Stats',
        },

        name:'FinancialStats',

    }

</script>
